(() => {
  if (window.teamVitalityHeroCountdownReady) return;

  window.teamVitalityHeroCountdownReady = true;

  const parseCountdownTime = (rawTime) => {
    if (!rawTime) return NaN;

    const trimmedTime = rawTime.trim();
    const isoLikeMatch = trimmedTime.match(
      /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[ T](\d{1,2})(?::(\d{1,2}))?(?::(\d{1,2}))?)?$/
    );

    if (isoLikeMatch) {
      const [, year, month, day, hour = '0', minute = '0', second = '0'] = isoLikeMatch;

      return new Date(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hour),
        Number(minute),
        Number(second)
      ).getTime();
    }

    return new Date(trimmedTime).getTime();
  };

  const padTime = (value) => String(value).padStart(2, '0');

  const initTeamVitalityCountdown = (root = document) => {
    root.querySelectorAll('[data-team-vitality-countdown]').forEach((countdown) => {
      if (countdown.dataset.countdownInitialized === 'true') return;

      const targetTime = parseCountdownTime(countdown.dataset.countdownTime);
      const daysNode = countdown.querySelector('[data-countdown-days]');
      const hoursNode = countdown.querySelector('[data-countdown-hours]');
      const minutesNode = countdown.querySelector('[data-countdown-minutes]');

      if (Number.isNaN(targetTime) || !daysNode || !hoursNode || !minutesNode) {
        countdown.hidden = true;
        return;
      }

      const updateCountdown = () => {
        const distance = Math.max(targetTime - Date.now(), 0);
        const totalMinutes = Math.floor(distance / 60000);
        const days = Math.floor(totalMinutes / 1440);
        const hours = Math.floor((totalMinutes % 1440) / 60);
        const minutes = totalMinutes % 60;

        const nextDays = padTime(days);
        const nextHours = padTime(hours);
        const nextMinutes = padTime(minutes);

        if (daysNode.textContent !== nextDays) daysNode.textContent = nextDays;
        if (hoursNode.textContent !== nextHours) hoursNode.textContent = nextHours;
        if (minutesNode.textContent !== nextMinutes) minutesNode.textContent = nextMinutes;

        if (distance === 0 && countdown.dataset.countdownInterval) {
          window.clearInterval(Number(countdown.dataset.countdownInterval));
          delete countdown.dataset.countdownInterval;
        }
      };

      updateCountdown();
      countdown.dataset.countdownInterval = String(window.setInterval(updateCountdown, 1000));
      countdown.dataset.countdownInitialized = 'true';
    });
  };

  const destroyTeamVitalityCountdown = (root = document) => {
    root.querySelectorAll('[data-team-vitality-countdown]').forEach((countdown) => {
      if (countdown.dataset.countdownInterval) {
        window.clearInterval(Number(countdown.dataset.countdownInterval));
      }

      delete countdown.dataset.countdownInterval;
      delete countdown.dataset.countdownInitialized;
    });
  };

  document.addEventListener('DOMContentLoaded', () => initTeamVitalityCountdown());
  document.addEventListener('shopify:section:load', (event) => initTeamVitalityCountdown(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyTeamVitalityCountdown(event.target));
})();
